import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { ActivityIcon, CircleDotIcon, SquareIcon, SmileIcon, HeartIcon } from 'lucide-react';
export function PTVersatility() {
  const areas = [{
    name: 'Elbows',
    description: 'To address sagging or loose skin',
    icon: ActivityIcon
  }, {
    name: 'Knees',
    description: 'For tightening and smoothing the skin',
    icon: CircleDotIcon
  }, {
    name: 'Abdomen',
    description: 'To improve skin laxity and texture',
    icon: SquareIcon
  }, {
    name: 'Neck',
    description: 'For lifting and reducing the appearance of neck lines',
    icon: SmileIcon
  }, {
    name: 'Décolletage',
    description: 'To rejuvenate and tighten the skin',
    icon: HeartIcon
  }];
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-1785">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1786">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1787">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-1788">
            VERSATILITY OF PDO THREADS
          </h2>

          <p className="font-serif italic text-[#B0B0B0] text-[17px] mb-6 max-w-[700px]" data-id="element-1789">
            PDO threads are not limited to facial treatments! They can be used
            practically anywhere on the body to improve skin texture and provide
            lifting. Common areas include:
          </p>

          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-1790"></div>
        </AnimateOnScroll>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 max-w-[1100px] mx-auto" data-id="element-1791">
          {areas.map((area, index) => <AnimateOnScroll key={index} delay={index * 100} data-id="element-1792">
              <div className="bg-[#111111] p-8 flex flex-col items-center justify-center text-center h-full group hover:shadow-[0_4px_20px_rgba(255,20,147,0.15)] transition-all duration-300 border-b-2 border-transparent hover:border-[#FF1493]" data-id="element-1793">
                <area.icon size={40} strokeWidth={1.5} className="text-[#FF1493] mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-1794" />
                <h3 className="text-white text-base font-bold uppercase tracking-[1px] font-[Poppins,_sans-serif] mb-2" data-id="element-1795">
                  {area.name}
                </h3>
                <p className="text-[#B0B0B0] text-sm font-body" data-id="element-1796">
                  {area.description}
                </p>
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}